module.exports = __webpack_public_path__ + "img/erp-logos_0037_cin7.ab3543c1.jpg";